import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 45 45",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsx("path", {
				className: "icon-fill-secondary",
				d: "M34.6 41.2c-1.8 0-2.8-.5-3.6-1l-.6-.3 1-2.3c.3.1.6.3.8.4.7.4 1.2.7 2.4.7s1.7-.3 2.4-.7c.8-.4 1.8-1 3.6-1v2.5c-1.2 0-1.7.3-2.4.7-.8.5-1.8 1-3.6 1z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-fill-secondary",
				d: "M10.4 41.2c-1.8 0-2.8-.5-3.6-1-.7-.4-1.2-.7-2.4-.7V37c1.8 0 2.8.5 3.6 1 .7.4 1.2.7 2.4.7s1.7-.3 2.4-.7c.3-.2.5-.3.8-.4l1 2.3-.6.3c-.7.4-1.7 1-3.6 1z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-fill-secondary",
				d: "M4.4 37v2.5c-1.2 0-1.7.3-2.4.7-.4.2-.9.5-1.6.7-.2.1-.3.1-.4.1v-2.6c.2-.1.5-.2.7-.4.8-.4 1.8-1 3.7-1z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-fill-secondary",
				d: "M45 38.4V41c-.2 0-.3-.1-.5-.1-.6-.2-1-.5-1.4-.7-.7-.4-1.2-.7-2.4-.7V37c1.8 0 2.8.5 3.6 1 .2.2.5.3.7.4z"
			})
		] }),
		/* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsx("path", {
				className: "icon-fill-secondary",
				d: "M34.6 33.3c-1.8 0-2.8-.5-3.6-1l-.1-.1 1.2-2.2.1.1c.7.4 1.2.7 2.4.7s1.7-.3 2.4-.7c.8-.4 1.8-1 3.6-1v2.5c-1.2 0-1.7.3-2.4.7-.8.5-1.8 1-3.6 1z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-fill-secondary",
				d: "M10.4 33.3c-1.8 0-2.8-.5-3.6-1-.7-.4-1.2-.7-2.4-.7v-2.5c1.8 0 2.8.5 3.6 1 .7.4 1.2.7 2.4.7s1.7-.3 2.4-.7l.2-.1 1.2 2.2-.2.2c-.8.4-1.8.9-3.6.9z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-fill-secondary",
				d: "M4.4 29.2v2.5c-1.2 0-1.7.3-2.4.7-.4.2-.9.5-1.6.7-.1 0-.2.1-.4.1v-2.6c.2-.1.5-.2.7-.4.8-.5 1.8-1 3.7-1z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-fill-secondary",
				d: "M45 30.5v2.6c-.2 0-.3-.1-.5-.1-.6-.2-1-.4-1.4-.7-.7-.4-1.2-.7-2.4-.7v-2.5c1.8 0 2.8.5 3.6 1 .2.2.5.3.7.4z"
			})
		] }),
		/* @__PURE__ */ _jsx("circle", {
			className: "icon-fill-secondary",
			cx: 22.5,
			cy: 34.3,
			r: 5
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-secondary",
			d: "M22.5 35.6c-.7 0-1.2-.6-1.2-1.2V7.3c0-.7.6-1.2 1.2-1.2s1.2.6 1.2 1.2v27.1c.1.6-.5 1.2-1.2 1.2z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-primary",
			d: "M36.7 9V6.5h-7.9v-.1c0-3.5-2.8-6.3-6.3-6.3s-6.3 2.8-6.3 6.3v19.2c-2.8 2-4.4 5.2-4.4 8.7 0 5.9 4.8 10.7 10.7 10.7 5.9 0 10.7-4.8 10.7-10.7 0-3.4-1.6-6.6-4.4-8.7v-3.3h7.9v-2.5h-7.9v-4.1h7.9v-2.5h-7.9V9h7.9zm-6 25.2c0 4.5-3.7 8.2-8.2 8.2s-8.2-3.7-8.2-8.2c0-2.8 1.4-5.4 3.8-6.9l.6-.4V6.4c0-2.1 1.7-3.8 3.8-3.8s3.8 1.7 3.8 3.8V27l.6.4c2.4 1.4 3.8 4 3.8 6.8z"
		})
	]
});
export default SvgIcon;
